import React,{useState,useEffect,useContext} from 'react'
import api from '../../services/api'
import { BigHead } from '@bigheads/core'
import { ModalContext} from '../../context/modal'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CardTableListManager = 
    ({id,typeCount,deposit,address,
    typeStructure,temperature,product,
    description,batch,series,initialValue,
    validate,client,statusStock,comments,picture1,
    picture2,picture3,picture4,page
    }) => {
    
    const [stateInput,setStateInput] = useState(false)
    const [users,setUsers] = useState([])
    const [usersInCountage,setUserInCountage] = useState([])
    const [userCountage,setUserContage] = useState(false)
    const {redirectToPage} = useContext(ModalContext)
    


    const getUsers = async (name) => {

        if(name != undefined){

            const response = await api.post('users/operation',{
                name:name
            })
            
            if(response.status == 404){

                setUsers([])
                return false
            }

            setUsers(response.data)
        }

    }
    const getUsersInCountage = async () => {

            const response = await api.post("user/countages",{
                "client":client,
            })
            
            if(response.status == 404){
                setUsers([])
                return false
            }

            setUserInCountage(response.data)
        

    }
    const addUserInCountage = async (name,mail) => {

        const response = await api.post("user/countage",{
            "name":name,
            "client":client,
            "mail":mail,
            "id_countage":id

        })

        if(response.status == 200){
            setUserContage(!userCountage)

            return false
        }
        
             

        toast.error('Usuário já existe na contagem', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });

            
        

    }


    
    useEffect(() => {

        getUsersInCountage()
    },[client])

    useEffect(() => {

        getUsersInCountage()


    },[userCountage])


    return(

        <div style={{height:"89px", width:usersInCountage.length == 0 || usersInCountage.length == 1 ? "2300px" :"2300px",borderRadius:"10px",border:"1px solid #D7D7D7",background:"white",display:"flex",paddingTop:"15px",paddingLeft:"20px",marginTop:"0.8125rem",position:"relative"}}>
        <ToastContainer />

        {page == "Inventary" 
        
        ?
    
        <></>
        :

        stateInput == true 
        
            ?
    
            <div>
            <input onChange={(e) => getUsers(e.target.value)} onBlur={() => {
    
                setTimeout(() => {
    
                    setStateInput(false)
    
                },[200])
    
            }} style={{width:"281px",height:"44px", border:"1px solid #D7D7D7",borderRadius:"7px",paddingLeft:"0.9rem"}}/>
            
    
            {users.length > 0 
            
            ?
            <div style={{width:"240px",border:"1px solid #D7D7D7",background:"white",position:"absolute",zIndex:"1"}}>
            
            {users.map(item => {
    
    
                return(
    
                
                    <div key={item.id} onClick={() => addUserInCountage(item.name,item.mail)}  style={{background:"#F7F9FB",borderRadius:"60px",width:"170.73px",height:"39px",marginTop:"9px",marginLeft:"4px",display:"flex",alignItems:"center",cursor:"pointer"}}>
                
                    {item.picture != undefined 
                    
                    ?
                
                    <img src={item.picture}  style={{marginLeft:"0.5rem",width:"25px",height:"25px",borderRadius:"100%"}}/>
                    :
                    <BigHead
                    width={30}
                    accessory="shades"
                    body="chest"
                    circleColor="blue"
                    clothing="tankTop"
                    clothingColor="black"
                    eyebrows="angry"
                    eyes="wink"
                    facialHair="mediumBeard"
                    graphic="vue"
                    hair="short"
                    hairColor="black"
                    hat="none"
                    hatColor="green"
                    lashes="false"
                    lipColor="purple"
                    mask="true"
                    faceMask="true"
                    mouth="open"
                    skinTone="brown"
                    />
                    }
    
                    
                    <p className="textNameTableListManager" style={{marginLeft:"0.5rem"}}>{item.name}</p>
    
                    </div>
    
                )
    
            })}
    
            <div style={{height:"20px"}}></div>
            </div>
    
            :
            <></>
            }
            </div>
            :
    
            <div onClick={() => setStateInput(true)}  style={{minWidth:"190px",width:usersInCountage.length == 1 ||   usersInCountage.length == 0 ? "190px" :"auto",height:"48px", border:"1px solid #D7D7D7",borderRadius:"7px"}}>
            
            <div style={{display:"flex",alignItems:"center",width:"100%"}}>
            {usersInCountage.map(item => {
    
    
                if(item.id_countage == id){
    
                    return(
    
                        <div style={{display:"flex",alignItems:"center",marginTop:"0.3rem",width:"150px",marginLeft:"0.5rem",marginRight:"0.5rem"}}>
                        {item.picture != undefined 
                    
                            ?
                        
                            <img src={item.picture} style={{marginLeft:"0.5rem",width:"65px",height:"65px",borderRadius:"100%"}}/>
                            :
                            <BigHead
                            width={30}
                            accessory="shades"
                            body="chest"
                            circleColor="blue"
                            clothing="tankTop"
                            clothingColor="black"
                            eyebrows="angry"
                            eyes="wink"
                            facialHair="mediumBeard"
                            graphic="vue"
                            hair="short"
                            hairColor="black"
                            hat="none"
                            hatColor="green"
                            lashes="false"
                            lipColor="purple"
                            mask="true"
                            faceMask="true"
                            mouth="open"
                            skinTone="brown"
                            />
                            }
                            <p className="textNameTableListManager" style={{marginLeft:"0.5rem"}}>{item.name}</p>
                            
                        </div>
    
                    )
    
    
                }
    
            })}
            </div>
    
            
            </div>
            }

        

    

        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>

        <p className="textPrimartyListInventary" style={{width:"100px"}}>{typeCount}</p>
        <p className="textSecondaryListInventary">Tipo</p>
        </div>

        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>

        <p className="textPrimartyListInventary" style={{width:"100px"}}>{deposit}</p>
        <p className="textSecondaryListInventary">Depósito</p>
        </div>

        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>
        <p className="textPrimartyListInventary" style={{width:"100px"}}>{address}</p>
        <p className="textSecondaryListInventary">Endereço</p>
        </div>

        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>
        <p className="textPrimartyListInventary" style={{width:"100px"}}>{typeStructure}</p>
        <p className="textSecondaryListInventary">Tipo de estrutura</p>
        </div>

        
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>

        <p className="textPrimartyListInventary" style={{width:"100px"}}>{temperature}</p>
        <p className="textSecondaryListInventary">Temperatura</p>
        </div>


        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>

        <p className="textPrimartyListInventary"  style={{width:"100px"}}>{product}</p>
        <p className="textSecondaryListInventary">Produto</p>
        </div>

        
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>

        
        <p className="textPrimartyListInventary" style={{width:"100px"}}>{description}</p>
        <p className="textSecondaryListInventary">Descrição</p>

        </div>


        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>

        <p className="textPrimartyListInventary"  style={{width:"100px"}}>{batch}</p>
        <p className="textSecondaryListInventary">Lote</p>
        </div>


        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>

        <p className="textPrimartyListInventary" style={{width:"100px"}}>{series}</p>
        <p className="textSecondaryListInventary">Série</p>
        </div>


        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>

        <p className="textPrimartyListInventary"  style={{width:"100px"}}>{validate}</p>
        <p className="textSecondaryListInventary">Validade</p>
        </div>

        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>
        <p className="textPrimartyListInventary" style={{width:"100px"}}>{initialValue}</p>
        <p className="textSecondaryListInventary">Saldo Inicial</p>
        </div>
        

        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>
        <p className="textPrimartyListInventary"  style={{width:"80px"}}>900</p>
        <p className="textSecondaryListInventary">Saldo Final</p>
        </div>

        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>
        <p className="textPrimartyListInventary"  style={{width:"80px"}}>0</p>
        <p className="textSecondaryListInventary">Variação</p>
        </div>

 
    
       
        {comments == null 
        
        ?
        <></>
        :

        <div style={{display:"flex",flexDirection:"column",alignItems:"center",position:"relative"}}>
        <p className="textPrimartyListInventary" style={{width:"220px"}}>{comments}</p>
        <p className="textSecondaryListInventary">Comentários</p>
        </div>
        }
        {page == "Inventary" 
        
        ?
        <></>
        
        :
        <div onClick={() => redirectToPage(id)} style={{width:"220px",position:"absolute",right:"-180px",top:"37px",cursor:"pointer"}}>
        <div style={{width:"4px",height:"4px",background:"black",borderRadius:"100%"}}></div>
        <div style={{width:"4px",height:"4px",background:"black",borderRadius:"100%",marginTop:"2px"}}></div>
        <div style={{width:"4px",height:"4px",background:"black",borderRadius:"100%",marginTop:"2px"}}></div>
        </div>
        }
  


        {
            picture1 != undefined 
            
            ?
            <img src={picture1} style={{width:"50px",height:"50px",borderRadius:"6px",marginLeft:"20px"}}/>
            :
            <></>
        }

        
        {
            picture2 != undefined 
            
            ?
            <img src={picture2} style={{width:"50px",height:"50px",borderRadius:"6px",marginLeft:"20px"}}/>
            :
            <></>
        }

                
        {
            picture3 != undefined 
            
            ?
            <img src={picture3} style={{width:"50px",height:"50px",borderRadius:"6px",marginLeft:"20px"}}/>
            :
            <></>
        }

                   
        {
            picture4 != undefined 
            
            ?
            <img src={picture4} style={{width:"50px",height:"50px",borderRadius:"6px",marginLeft:"20px"}}/>
            :
            <></>
        }




        </div>

    )

}

export default CardTableListManager